
import React from 'react';
import { Route } from 'react-router-dom';
import Conditions from '@/pages/Conditions';
import AcneAndScars from '@/pages/conditions/AcneAndScars';
import BodyFatDoubleChin from '@/pages/conditions/BodyFatDoubleChin';
import DullDehydratedSkin from '@/pages/conditions/DullDehydratedSkin';
import FinesLinesWrinkles from '@/pages/conditions/FinesLinesWrinkles';
import HairThinning from '@/pages/conditions/HairThinning';
import PigmentationSpots from '@/pages/conditions/PigmentationSpots';
import ScarringStretchMarks from '@/pages/conditions/ScarringStretchMarks';
import UnevenToneTexture from '@/pages/conditions/UnevenToneTexture';

export const ConditionRoutes = () => (
  <>
    <Route path="/conditions" element={<Conditions />} />
    <Route path="/conditions/acne-and-scars" element={<AcneAndScars />} />
    <Route path="/conditions/body-fat-double-chin" element={<BodyFatDoubleChin />} />
    <Route path="/conditions/dull-dehydrated-skin" element={<DullDehydratedSkin />} />
    <Route path="/conditions/fine-lines-wrinkles" element={<FinesLinesWrinkles />} />
    <Route path="/conditions/hair-thinning" element={<HairThinning />} />
    <Route path="/conditions/pigmentation-spots" element={<PigmentationSpots />} />
    <Route path="/conditions/scarring-stretch-marks" element={<ScarringStretchMarks />} />
    <Route path="/conditions/uneven-tone-texture" element={<UnevenToneTexture />} />
  </>
);
